/* eslint-disable react-hooks/exhaustive-deps */

import { Card, Tab, Tabs, Typography, IconButton, Stack } from '@mui/material';
import { React, useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import SessionChartTab from './SessionChartTab';
import { friendlyNameConverter } from '../../../services/localizationService';
import Iconify from '../../../components/iconify';

SessionPageChartTabbedDisplay.propTypes = {
  session: PropTypes.object,
  events: PropTypes.array,
  currentTime: PropTypes.object,
  sensorByTypes: PropTypes.object,
  onChartClick: PropTypes.func,
  eventSensor: PropTypes.string,
  setSensor: PropTypes.string,
  openExport: PropTypes.func,
};

export default function SessionPageChartTabbedDisplay(props) {
  const [tabIndex, setTabIndex] = useState(0);
  const [charts, setCharts] = useState([]);
  const [dataContainerKeys, setDataContainerKeys] = useState([]);
  const [chartCount, setChartCount] = useState(1);
  const handleTabChange = (event, newTabIndex) => {
    setTabIndex(newTabIndex);
  };

  useEffect(() => {
    createAllCharts();
  }, []);

  const createAllCharts = () => {
    const dataContainerKeys = Object.keys(props.session.data);
    setDataContainerKeys(dataContainerKeys);

    // Filter out GPS-related sensor data (altitude, latitude, longitude)
    const filteredKeys = dataContainerKeys.filter((key) => {
      const sensorType = key.split(':').pop().toLowerCase();
      return !['altitude', 'latitude', 'longitude'].includes(sensorType);
    });

    const charts = filteredKeys.map((key, index) => ({
      id: index,
      name: friendlyNameConverter(key),
      labels: props.session.data[key].map((i) => i.time),
      data: createData(key),
    }));
    // Sort by name
    charts.sort((a, b) => a.name.localeCompare(b.name));
    setCharts(charts);
  };

  const createData = (dataContainerKey) => {
    const series = [
      {
        type: 'line',
        name: dataContainerKey,
        fill: 'solid',
        data: props.session.data[dataContainerKey].map((i) => i.value),
      },
    ];
    return series;
  };

  const createChart = () => {
    setChartCount(chartCount + 1);
    setTabIndex(chartCount);
  };

  // eslint-disable-next-line no-unused-vars
  function ItemList({ count }) {
    const items = [];
    for (let i = 1; i <= count; i += 1) {
      items.push(<Tab key={i.toString()} label={i.toString()} />);
    }
    return { items };
  }

  const sensorTypes = Object.keys(props.sensorByTypes);
  // eslint-disable-next-line no-unused-vars
  const activeCharts = charts.filter((chart) => dataContainerKeys.includes(chart.name));
  return (
    <Card sx={{ overflow: 'visible', zIndex: 10 }}>
      {/* <Tabs value={tabIndex} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
        {[...Array(chartCount)].map((_, index) => (
          <Tab key={index} label={`Tab ${index}`}>
            <SessionChartTab
              chart={charts[tabIndex]}
              charts={charts}
              sensorTypes={sensorTypes}
              events={props.events}
              tabindex={tabIndex}
              currentTime={props.currentTime}
              onChartClick={props.onChartClick}
              eventSensor={props.eventSensor}
            />
          </Tab>
        ))}
        <Tab label="+" onClick={createChart} />
      </Tabs> */}
      <Stack direction="row" spacing={2} alignItems="right" justifyContent="flex-end">
        <IconButton
          color="primary"
          onClick={() => {
            props.openExport();
          }}
          title="Export Data"
        >
          <Iconify icon="eva:download-fill" />
        </IconButton>
      </Stack>
      {charts.length === 0 && (
        <Typography variant="h6" align="center">
          No charts to display
        </Typography>
      )}
      {charts.length > 0 && (
        <SessionChartTab
          chart={charts[tabIndex]}
          charts={charts}
          sensorTypes={sensorTypes}
          events={props.events}
          tabindex={tabIndex}
          currentTime={props.currentTime}
          onChartClick={props.onChartClick}
          eventSensor={props.eventSensor}
          setSensor={props.setSensor}
        />
      )}
    </Card>
  );
}
